/**
 * The transport contract shared by the API and the web client.
 *
 * Every endpoint answers with exactly one of these two envelopes (spec section 77):
 *
 *   { "success": true,  "data": ... }
 *   { "success": false, "error": { "code": "...", "message": "..." } }
 */
/** Machine-readable error codes. The web client branches on these, never on messages. */
export const ErrorCode = {
    /* 400 */
    VALIDATION_ERROR: 'VALIDATION_ERROR',
    BAD_REQUEST: 'BAD_REQUEST',
    /* 401 */
    UNAUTHENTICATED: 'UNAUTHENTICATED',
    INVALID_CREDENTIALS: 'INVALID_CREDENTIALS',
    TOKEN_EXPIRED: 'TOKEN_EXPIRED',
    INVALID_TOKEN: 'INVALID_TOKEN',
    /* 403 */
    FORBIDDEN: 'FORBIDDEN',
    ACCOUNT_INACTIVE: 'ACCOUNT_INACTIVE',
    LESSON_LOCKED: 'LESSON_LOCKED',
    SKIP_NOT_ALLOWED: 'SKIP_NOT_ALLOWED',
    ATTEMPT_LIMIT_REACHED: 'ATTEMPT_LIMIT_REACHED',
    REQUIREMENTS_NOT_MET: 'REQUIREMENTS_NOT_MET',
    /* 404 */
    NOT_FOUND: 'NOT_FOUND',
    /* 409 */
    CONFLICT: 'CONFLICT',
    EMAIL_IN_USE: 'EMAIL_IN_USE',
    ALREADY_COMPLETED: 'ALREADY_COMPLETED',
    ATTEMPT_ALREADY_OPEN: 'ATTEMPT_ALREADY_OPEN',
    ATTEMPT_CLOSED: 'ATTEMPT_CLOSED',
    /* 422 */
    UNPROCESSABLE: 'UNPROCESSABLE',
    /* 429 */
    RATE_LIMITED: 'RATE_LIMITED',
    /* 500 */
    INTERNAL_ERROR: 'INTERNAL_ERROR',
    /* Client-side only: the request never reached the server. */
    NETWORK_ERROR: 'NETWORK_ERROR',
};
export const DEFAULT_PAGE = 1;
export const DEFAULT_PAGE_SIZE = 20;
export const MAX_PAGE_SIZE = 100;
/* -------------------------------------------------------------------------- */
/* Helpers                                                                    */
/* -------------------------------------------------------------------------- */
export function isApiSuccess(res) {
    return res.success === true;
}
export function isApiError(res) {
    return res.success === false;
}
/** Build the pagination meta block from a total count and the requested slice. */
export function buildPaginationMeta(total, page, pageSize) {
    const safePageSize = Math.max(1, pageSize);
    const totalPages = Math.max(1, Math.ceil(total / safePageSize));
    return {
        page,
        pageSize: safePageSize,
        total,
        totalPages,
        hasNextPage: page < totalPages,
        hasPreviousPage: page > 1,
    };
}
//# sourceMappingURL=api.js.map